// extracted by mini-css-extract-plugin
module.exports = {"destinationWrapper":"destinationSlug_destinationWrapper__BcdwQ","accordionContainer":"destinationSlug_accordionContainer__lLbvu"};